import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";

import truck1 from "../../../assets/img/esg/esgFour/truck1.webp";
import gheco from "../../../assets/img/fleetStructure/fleetFour/GHECO DRIVING.png";
import seta from "../../../assets/img/components/seta.webp";
import arrowLeft from "../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../assets/img/components/arrow-right.webp";

import "swiper/css";
import "swiper/css/navigation";

function FleetFour() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const data = [
    {
      id: 1,
      title: t("fleet_four_card1_title"),
      class: "twoText",
      content1: [t("fleet_four_card1_text1")],
      content2: [t("fleet_four_card1_text2")],
      imageUrl: truck1,
    },
    {
      id: 2,
      title: t("fleet_four_card2_title"),
      class: "oneText gheco",
      content1: [t("fleet_four_card2_text1")],
      imageUrl: gheco,
    },
    {
      id: 4,
      class: "twoText",
      title: t("fleet_four_card3_title"),
      content1: [t("fleet_four_card3_text1")],
      content2: [t("fleet_four_card3_text2")],
      //imageUrl: img3,
    },
    {
      id: 5,
      class: "oneText",
      title: t("fleet_four_card4_title"),
      content1: [t("fleet_four_card4_text1")],
      //imageUrl: img3,
    },
    {
      id: 6,
      class: "oneText",
      title: t("fleet_four_card5_title"),
      content1: [t("fleet_four_card5_text1")],
      //imageUrl: img3,
    },
    {
      id: 7,
      class: "oneText",
      title: t("fleet_four_card6_title"),
      content1: [t("fleet_four_card6_text1")],
      //imageUrl: img3,
    },
    {
      id: 8,
      class: "oneText",
      title: t("fleet_four_card7_title"),
      content1: [t("fleet_four_card7_text1")],
      //imageUrl: img3,
    },
    {
      id: 9,
      class: "oneText",
      title: t("fleet_four_card8_title"),
      content1: [t("fleet_four_card8_text1")],
      //imageUrl: img3,
    },
    {
      id: 10,
      class: "oneText",
      title: t("fleet_four_card9_title"),
      content1: [t("fleet_four_card9_text1")],
      //imageUrl: img3,
    },
    {
      id: 11,
      class: "oneText",
      title: t("fleet_four_card10_title"),
      content1: [t("fleet_four_card10_text1")],
      //imageUrl: img3,
    },
  ];

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
      <div className={`fleetFour ${isVisible ? "visible" : ""}`}>
        <div className="fleetFourTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("fleet_four_title")} <span>{t("fleet_four_title_span")}</span>
          </h1>
        </div>
        <Swiper
          className={`${isVisible ? "visible" : ""}`}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          modules={[Navigation]}
          speed={800}
          slidesPerView={"1"}
          spaceBetween={200}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {data.map((item) => (
            <SwiperSlide key={item.id}>
              <div className={`card ${item.class}`}>
                <div className="cardText">
                  <h3 className={`${isVisible ? "visible" : ""}`}>
                    {item.title}
                  </h3>
                  <p className={`text1 ${isVisible ? "visible" : ""}`}>
                    <img src={seta} className="seta" alt="" />
                    {item.content1}
                  </p>
                  <p className={`text2 ${isVisible ? "visible" : ""}`}>
                    <img src={seta} className="seta" alt="" />
                    {item.content2}
                  </p>
                  <p className={`text3 ${isVisible ? "visible" : ""}`}>
                    <img src={seta} className="seta" alt="" />
                    {item.content3}
                  </p>
                  <p className={`text4 ${isVisible ? "visible" : ""}`}>
                    <img src={seta} className="seta" alt="" />
                    {item.content4}
                  </p>
                </div>
                <img
                  className={`${isVisible ? "visible" : ""}`}
                  src={item.imageUrl}
                  alt=""
                  width={"600px"}
                />
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}
export default FleetFour;
